import React from 'react';
import { Img } from 'react-image';
import { useAchievements } from '../../Context/AchievementsProvider';
import { AchievementTier } from '../../Types/AchievementTier';
import {
  UserAchievement,
  UserAchievementStatus,
} from '../../Types/UserAchievement';
import { AchievementProgressBar } from './AchievementProgressBar';

interface UserAchievementCardProps {
  userAchievement: UserAchievement;
}

export const UserAchievementCard: React.FC<UserAchievementCardProps> = ({
  userAchievement,
}) => {
  const { getAchievementImage } = useAchievements();

  const progress =
    userAchievement.unitsRequired > 0
      ? (userAchievement.unitsProgress / userAchievement.unitsRequired) * 100
      : 0;
  const isCompleted =
    userAchievement.status === UserAchievementStatus.Completed;

  return (
    <div
      className="flex flex-col p-6 bg-white rounded-xl border border-gray-200"
      title={userAchievement.createdAt?.toLocaleDateString()}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="text-center">
          <div className="text-base font-bold ">{userAchievement.title}</div>
          <div className="text-sm text-gray-600 h-10 line-clamp-2">
            {userAchievement.description}
          </div>
        </div>
        <div className="relative w-16 h-16 flex items-center justify-center">
          <Img
            src={getAchievementImage(userAchievement)}
            alt={userAchievement.title}
            className="w-16 h-16"
          />
        </div>
        <div className="w-full h-8">
          {userAchievement.createdAt ? (
            <>
              <AchievementProgressBar
                progress={progress}
                tier={userAchievement.tier}
              />
              <div className="text-xs text-gray-600 text-center mt-2">
                {!isCompleted ? (
                  <>
                    {userAchievement.unitsProgress ?? 0}/
                    {userAchievement.unitsRequired} for{' '}
                    {userAchievement.tier === AchievementTier.Bronze
                      ? 'Bronze'
                      : userAchievement.tier === AchievementTier.Silver
                        ? 'Silver'
                        : 'Gold'}
                  </>
                ) : (
                  'Completed!'
                )}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
